var render = function render(){var _vm=this,_c=_vm._self._c;return (!Array.isArray(_vm.reportsList))?_c('div',[(!_vm.loadingReports)?_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.templateMessage)}})]):_c('div',[_c('b-skeleton')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }